<template>
  <div>
    <div
      class="ui blue label"
      :style="{ opacity: disabled ? 0.3 : 1 }"
      v-for="i in items"
      :key="i.key"
    >
      <a v-if="!disabled"><i class="remove icon" @click.stop="removeHandler(i)"></i></a>
      <i v-else class="remove icon"></i>
      {{ i.key }}
      <div class="detail">{{ i.value }}</div>
    </div>
    <span v-if="items && !items.length">
      {{ $t('NO_THING_YET', { thing: $tc('INPUT', 2) }) }}
    </span>
  </div>
</template>

<script>
// @flow
export default {
  name: 'key-value-item-list',

  props: {
    items: {
      type: Array,
      default: () => []
    },
    removeHandler: {
      type: Function,
      default: () => ''
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  }
}
//
</script>
